/* R&R mobile scroll recovery v4 — Sep 8, 2026.
   Keeps page scroll enabled unless a real, visible R&R/native modal is actually open. */
(() => {
  if (window.__rrMobileScrollRecoveryV4Loaded) return;
  window.__rrMobileScrollRecoveryV4Loaded = true;

  const FREE_CLASS = 'rr-scroll-free';
  const STYLE_ID = 'rr-scroll-recovery-v4-style';
  let raf = 0;
  let observer = null;

  const visible = el => {
    if (!el) return false;
    if (el.hidden) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    const rect = el.getBoundingClientRect?.();
    return !rect || (rect.width > 0 && rect.height > 0);
  };

  const giftOpen = () => {
    const el = document.getElementById('rr-case-gift-picker');
    return !!(el && el.classList.contains('is-open') && el.getAttribute('aria-hidden') !== 'true' && visible(el));
  };

  const cartOpen = () => {
    const el = document.getElementById('rr-cart-sheet');
    return !!(el && el.classList.contains('is-open') && el.getAttribute('aria-hidden') !== 'true' && visible(el));
  };

  const searchOpen = () => {
    const el = document.getElementById('rr-search-dialog');
    return !!(el && (el.open || el.hasAttribute('open')) && visible(el));
  };

  const signupOpen = () => {
    const candidates = document.querySelectorAll('[data-rr-newsletter], dialog[data-rr-newsletter], .rr-newsletter-dialog');
    return Array.from(candidates).some(el => (el.open || el.hasAttribute('open') || el.getAttribute('aria-hidden') === 'false') && visible(el));
  };

  const menuOpen = () => Array.from(document.querySelectorAll('details.rr-menu[open], details.rr-mobile-collections[open]')).some(visible);

  const nativeDrawerOpen = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !visible(drawer)) return false;
    return drawer.classList.contains('cart-open') || drawer.getAttribute('aria-hidden') === 'false' || !!drawer.querySelector('.cart-open');
  };

  const realModalOpen = () => giftOpen() || cartOpen() || searchOpen() || signupOpen() || menuOpen() || nativeDrawerOpen();

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      html.${FREE_CLASS}, body.${FREE_CLASS}{
        overflow-y:auto!important;
        overflow-x:hidden!important;
        position:static!important;
        top:auto!important;
        height:auto!important;
        max-height:none!important;
        touch-action:pan-y pinch-zoom!important;
        overscroll-behavior-y:auto!important;
      }
      .rr-case-gift__body,.rr-cart-sheet__body{
        min-height:0!important;
        overflow-y:auto!important;
        overflow-x:hidden!important;
        -webkit-overflow-scrolling:touch!important;
        touch-action:pan-y!important;
        overscroll-behavior-y:contain!important;
      }
    `;
    document.head.append(style);
  }

  function clearInlineScrollLock(el) {
    if (!el?.style) return;
    ['overflow','overflow-y','position','top','height','max-height','touch-action','overscroll-behavior','overscroll-behavior-y'].forEach(prop => {
      const value = el.style.getPropertyValue(prop);
      if (!value) return;
      const normalized = String(value).toLowerCase();
      if (prop === 'overflow' || prop === 'overflow-y') {
        if (normalized.includes('hidden') || normalized.includes('clip')) el.style.removeProperty(prop);
      } else if (prop === 'position') {
        if (normalized.includes('fixed')) el.style.removeProperty(prop);
      } else {
        el.style.removeProperty(prop);
      }
    });
  }

  function clearKnownStaleLocks() {
    const body = document.body;
    const html = document.documentElement;
    if (!body || !html) return;

    if (!giftOpen()) {
      body.classList.remove('rr-case-gift-open');
      html.classList.remove('rr-case-gift-open');
    }
    if (!cartOpen()) {
      body.classList.remove('rr-cart-sheet-open');
      html.classList.remove('rr-cart-sheet-open');
    }
    if (!searchOpen()) {
      body.classList.remove('rr-search-open');
      html.classList.remove('rr-search-open');
    }
    if (!signupOpen()) html.classList.remove('rr-signup-open');

    body.classList.remove('overflow-hidden','padding-scrollbar');
    clearInlineScrollLock(body);
    clearInlineScrollLock(html);

    try {
      const popup = window.Alpine?.store?.('xPopup');
      if (popup && !nativeDrawerOpen() && !menuOpen() && !searchOpen() && !signupOpen()) {
        if (popup.open) popup.open = false;
        if (popup.openVideoShopping) popup.openVideoShopping = false;
      }
    } catch {}
  }

  function reconcileScrollState() {
    raf = 0;
    injectStyles();
    const body = document.body;
    const html = document.documentElement;
    if (!body || !html) return;

    if (realModalOpen()) {
      body.classList.remove(FREE_CLASS);
      html.classList.remove(FREE_CLASS);
      return;
    }

    clearKnownStaleLocks();
    body.classList.add(FREE_CLASS);
    html.classList.add(FREE_CLASS);
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(reconcileScrollState);
  }

  function init() {
    injectStyles();
    reconcileScrollState();

    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      childList: true,
      attributeFilter: ['class','style','open','hidden','aria-hidden']
    });

    ['rr:gift-open','rr:gift-close','rr:cart-rendered','rr:cart-updated'].forEach(name => document.addEventListener(name, schedule));
    ['pageshow','focus','popstate','hashchange','orientationchange'].forEach(name => window.addEventListener(name, schedule, {passive:true}));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    document.addEventListener('touchstart', schedule, {passive:true,capture:true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
